var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaccFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3343_45655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 2H4.29167C3.025 2 2 3.025 2 4.29167V17.2083C2 18.475 3.025 19.5 4.29167 19.5H11.075C10.3417 18.5 9.91667 17.2833 9.91667 15.9583C9.91667 12.625 12.625 9.91667 15.9583 9.91667C16.025 9.91667 16.1 9.91667 16.1667 9.925V4.29167C16.1667 3.025 15.1417 2 13.875 2ZM5.33333 5.33333H8.66667C9.125 5.33333 9.5 5.70833 9.5 6.16667C9.5 6.625 9.125 7 8.66667 7H5.33333C4.875 7 4.5 6.625 4.5 6.16667C4.5 5.70833 4.875 5.33333 5.33333 5.33333ZM9.5 13.6667H5.33333C4.875 13.6667 4.5 13.2917 4.5 12.8333C4.5 12.375 4.875 12 5.33333 12H9.5C9.95833 12 10.3333 12.375 10.3333 12.8333C10.3333 13.2917 9.95833 13.6667 9.5 13.6667ZM12.8333 10.3333H5.33333C4.875 10.3333 4.5 9.95833 4.5 9.5C4.5 9.04167 4.875 8.66667 5.33333 8.66667H12.8333C13.2917 8.66667 13.6667 9.04167 13.6667 9.5C13.6667 9.95833 13.2917 10.3333 12.8333 10.3333Z",
    fill: "#EF7214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9583 20.3333C13.5458 20.3333 11.5833 18.3708 11.5833 15.9583C11.5833 13.5458 13.5458 11.5833 15.9583 11.5833C18.3708 11.5833 20.3333 13.5458 20.3333 15.9583C20.3333 18.3708 18.3708 20.3333 15.9583 20.3333ZM15.9583 13.25C14.4649 13.25 13.2499 14.465 13.2499 15.9583C13.2499 17.4517 14.4649 18.6667 15.9583 18.6667C17.4516 18.6667 18.6666 17.4517 18.6666 15.9583C18.6666 14.465 17.4516 13.25 15.9583 13.25Z",
    fill: "#EF7214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 22C20.9533 22 20.74 21.9183 20.5775 21.7558L17.8691 19.0475C17.5433 18.7217 17.5433 18.195 17.8691 17.8692C18.195 17.5433 18.7216 17.5433 19.0475 17.8692L21.7558 20.5775C22.0816 20.9033 22.0816 21.43 21.7558 21.7558C21.5933 21.9183 21.38 22 21.1666 22Z",
    fill: "#EF7214"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3343_45655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaccFound);
export default __webpack_public_path__ + "static/media/icon-pacc-found.abec5ecd59db38842f169c88161f3339.svg";
export { ForwardRef as ReactComponent };